import { render, staticRenderFns } from "./memberPermissionTab.vue?vue&type=template&id=29a8bf43&"
import script from "./memberPermissionTab.vue?vue&type=script&lang=js&"
export * from "./memberPermissionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports